module.exports = __webpack_public_path__ + "img/elf_31.1bc8db03.png";